const PDFPageEditorEnum = {
  PDF_PAGE_EDITOR_SET_DOCUMENT_READY_STATE: 'PDF_PAGE_EDITOR_SET_DOCUMENT_READY_STATE',
  PDF_PAGE_EDITOR_SET_ACTIVE_THUMBNAIL_INDEX: 'PDF_PAGE_EDITOR_SET_ACTIVE_THUMBNAIL_INDEX',
  PDF_PAGE_EDITOR_ADD_BLANK_PAGE: 'PDF_PAGE_EDITOR_ADD_BLANK_PAGE',
  PDF_PAGE_EDITOR_DELETE_PAGE: 'PDF_PAGE_EDITOR_DELETE_PAGE',
  PDF_PAGE_EDITOR_SET_PAGES: 'PDF_PAGE_EDITOR_SET_PAGES',
  PDF_PAGE_EDITOR_SET_PAGES_FROM_FILE: 'PDF_PAGE_EDITOR_SET_PAGES_FROM_FILE',
  PDF_PAGE_EDITOR_SET_EDIT_STATE_TO_TRUE: 'PDF_PAGE_EDITOR_SET_EDIT_STATE_TO_TRUE',
};

export default PDFPageEditorEnum;



// WEBPACK FOOTER //
// ./src-react/PDFPageEditor/PDFPageEditorConstants.jsx